var _circle, _rect, _rect2, _polygon, _rect3, _polygon2, _rect4, _circle2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 230,
    fill: "#0f172a"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 210,
    width: 290,
    height: 160,
    rx: 40,
    fill: "#2563eb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 250,
    width: 110,
    height: 70,
    rx: 18,
    fill: "#1e40af"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "180,160 210,120 240,160",
    fill: "#22c55e"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 160,
    width: 10,
    height: 40,
    fill: "#22c55e"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "330,390 300,430 270,390",
    fill: "#22c55e"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 295,
    y: 350,
    width: 10,
    height: 40,
    fill: "#22c55e"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 240,
    r: 70,
    fill: "#22c55e"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 265,
    textAnchor: "middle",
    fontSize: 75,
    fontWeight: "bold",
    fontFamily: "Arial, Helvetica, sans-serif",
    fill: "white"
  }, "BP")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d734fb5c745a3fd879667a11ccc62c56.svg";
export { ForwardRef as ReactComponent };